var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArchiveBoxIcon, ChevronLeftIcon, ChevronRightIcon, Cog8ToothIcon, TrashIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { TfiSave } from "react-icons/tfi";
import { toast } from "react-toastify";
import { archiveStageTasksRequest, deleteStageRequest, moveStageRequest, } from "../../../api/api";
import { OPEN_STAGE_EDIT_MODAL, PIPELINE_DELETE_STAGE, } from "../../../constants";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
import { AppContext } from "../../../providers/AppContextProvider";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem, } from "../WPQTDropdown";
function StageControlsDropdown({ stage }) {
    var _a, _b, _c, _d;
    const { dispatch, state: { activePipeline }, fetchAndSetPipelineData, } = useContext(ActivePipelineContext);
    const { modalDispatch } = useContext(ModalContext);
    const { state: { isUserAllowedToDelete }, } = useContext(AppContext);
    const stagesLength = (_b = (_a = activePipeline === null || activePipeline === void 0 ? void 0 : activePipeline.stages) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    const stageTasksLenght = (_d = (_c = stage.tasks) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    const stageOrder = +stage.stage_order;
    const showMoveLeft = stageOrder > 0 && stageOrder < stagesLength;
    const showMoveRight = stageOrder !== stagesLength - 1;
    const deleteStage = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteStageRequest(stage.id);
            dispatch({ type: PIPELINE_DELETE_STAGE, payload: stage.id });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to delete a stage", "quicktasker"));
        }
    });
    const openStageEditModal = () => {
        modalDispatch({
            type: OPEN_STAGE_EDIT_MODAL,
            payload: {
                stageToEdit: stage,
            },
        });
    };
    const moveStage = (direction) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield moveStageRequest(stage.id, direction);
            fetchAndSetPipelineData(activePipeline.id);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to move a stage", "quicktasker"));
        }
    });
    const archiveAllStageTasks = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield archiveStageTasksRequest(stage.id);
            fetchAndSetPipelineData(activePipeline.id);
            toast.success(sprintf(__("Archived all %s tasks", "quicktasker"), stage.name));
        }
        catch (error) {
            console.error(error);
            toast.error(sprintf(__("Failed to archive stage %s tasks", "quicktasker"), stage.name));
        }
    });
    return (_jsxs(WPQTDropdown, { menuBtn: ({ active }) => (_jsx(WPQTDropdownIcon, { isActive: active, IconComponent: Cog8ToothIcon })), children: [showMoveLeft && (_jsx(WPQTDropdownItem, { text: __("Move left", "quicktasker"), icon: _jsx(ChevronLeftIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: () => moveStage("left") })), showMoveRight && (_jsx(WPQTDropdownItem, { text: __("Move right", "quicktasker"), icon: _jsx(ChevronRightIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: () => moveStage("right") })), _jsx(WPQTDropdownItem, { text: __("Edit stage", "quicktasker"), icon: _jsx(TfiSave, { className: "wpqt-icon-blue wpqt-size-3" }), onClick: openStageEditModal }), _jsx(WPQTDropdownItem, { text: __("Archive all stage tasks", "quicktasker"), icon: _jsx(ArchiveBoxIcon, { className: "wpqt-icon-blue wpqt-size-4" }), onClick: archiveAllStageTasks, disabled: stageTasksLenght === 0, id: `item-dropdown-${stage.id}-archive`, tooltipText: stageTasksLenght === 0
                    ? __("No tasks to archive on the stage", "quicktasker")
                    : undefined }), isUserAllowedToDelete && (_jsx(WPQTDropdownItem, { text: __("Delete stage", "quicktasker"), icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: deleteStage, disabled: stageTasksLenght > 0, className: "!wpqt-mb-0", id: `item-dropdown-${stage.id}`, tooltipText: __("Stage can be deleted when there are no tasks on it", "quicktasker") }))] }));
}
export { StageControlsDropdown };
